<template>
	<div class="table-footer">
		<div class="row">
			<div class="col-md-4">
				<span>Show</span>
				<select
					class="form-control"
					v-model="showPerPage"
					id="resultsPerPage"
					@change="showPerPageChanged"
				>
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
				</select>
				<span>Entries</span>
			</div>
			<!-- <span class="data_notice" style="font-size: 14px;">
					* Tag indicators: P = Product, SA = Sponsored Ads, DSP = DSP 2
				</span> -->
			<div  class="col-md-4 text-center data_notice" style="font-size: 12px; margin-top: .25%;">
				* Tag indicators: P = Product, SA = Sponsored Ads, DSP = DSP
			</div>
			<div class="col-md-4 text-right">
				<a href="javascript:void(0)" v-if="currentPageNumber!=1" @click="getPreviousPageList()">Previous</a>
				<select
					class="form-control selectpicker"
					style="max-width:80px;"
					id="brandFilter"
					v-model="currentPageNumber"
					@change="getNewPageList()"
				>
					<option v-for="index in totalNoOfPages" :key="index" :value="index">{{index}}</option>
				</select>
				<a
					href="javascript:void(0)"
					v-if="(showPerPage == accountList.length) && (currentPageNumber!=totalNoOfPages)"
					@click="getNextPageList()"
				>Next</a>
				<div style="padding-right:0px;padding-top:5px">{{getCount()}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "TaggingListFooter",
		data() {
			return {
				totalNoOfPages: 1
			};
		},
		watch: {
			accountCount() {
				this.calculateIndexPerPage();
			}
		},
		computed: {
			accountCount: {
				set(val) {
					 
					this.$store.commit("accounts/updateAccountCount",val);
				},
				get() {
					 
					return this.$store.getters["accounts/getAccountCount"];
				}
			},
			showPerPage: {
				set(val) {
					this.currentPageNumber =1;
					sessionStorage.setItem("accounts:showPerPage", val);
				},
				get() {
					if (sessionStorage.getItem("accounts:showPerPage")) {
						return sessionStorage.getItem("accounts:showPerPage");
					}
					return this.$store.state.showPerPage;
				}
			},
			currentPageNumber: {
				set(val) {
					this.$store.state.currentPageNumber = val;
				},
				get() {
					return this.$store.state.currentPageNumber;
				}
			},
			accountList() {
				return this.$store.state.accounts.accountList;
			}
		},
		mounted() {
			this.calculateIndexPerPage();
		},
		methods: {
			calculateIndexPerPage() {
				this.totalNoOfPages = Math.ceil(
					this.accountCount / this.showPerPage
				);
			},
			getPreviousPageList() {
				if (this.currentPageNumber <= 1) {
					return;
				} else {
					this.currentPageNumber -= 1;
					this.$emit("filterList");
				}
			},
			getNextPageList() {
				this.currentPageNumber += 1;
				this.$emit("filterList");
			},
			getNewPageList() {
				this.$emit("filterList");
			},
			getCount() {
				let pageCount = this.showPerPage * (this.currentPageNumber - 1);
				let extendedcount =
					parseInt(pageCount) + parseInt(this.accountList.length);
				//return	pageCount+1 + ' to ' + extendedcount;
				return (
					"Showing " +
					(pageCount + 1) +
					" to " +
					extendedcount +
					" results of " +
					this.accountCount
				);
			},
			showPerPageChanged() {
				this.$emit("filterList");
			}
		}
	};
</script>

<style lang="scss">
</style>
